import React, { useState } from "react";
import MainContainer from "../components/partials/maincontainer";
import Input from "../components/partials/inputs";
import PrimaryBtn from "../components/partials/btn";
import SuccessModal from "../components/modals/successmodal";

const Recommendations = () => {
  const [modal, setModal] = useState(false);
  const Arr = [
		{
			label: "Enter Organisation Name*",
			placeholder: "Enter Organisation",
			footer: "Do not enter abbreviations",
		},
		{
			label: "Enter Focal Person Email*",
			placeholder: "Enter Email",
		},
		{
			label: "Tell us a bit about the organisation*",
			placeholder: "Enter Here",
		},
	];
	return (
		<div>
			<MainContainer>
				<div>
					<h3 className="text-4xl text-sec font-medium">Recommendation</h3>
					<p className="text-base font-normal mt-4 max-w-sm text-[#667085]">
						Do you know any organisation who will benefit greatly from this
						platform?
					</p>
					<form action="" onSubmit={e => e?.preventDefault()} className="mt-8">
						<div className="space-y-4 w-96">
							{Arr?.map(it => (
								<Input
									label={it?.label}
									placeholder={it?.placeholder}
									footer={it?.footer}
								/>
							))}
						</div>
						<div className="mt-8">
							<PrimaryBtn
								onClick={() => setModal(true)}
								text="Continue"
								width="w-96"
							/>
						</div>
					</form>
				</div>
			</MainContainer>
			{modal && <SuccessModal />}
		</div>
	);
};

export default Recommendations;
